import Filter from './SearchSection/Filter';
import Action from './SearchSection/Action';
import Header from './SearchSection/Header';
import Section from './Section'

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import { useDocs } from 'data/data';
import originalFilter from 'data/originalFilter';

function filterKeyword(doc, filterValues) {
    let keyword = filterValues.keyword.toLowerCase()

    if (keyword === "") {
        return true;
    }

    let filename = doc.original_filename.toLowerCase()
    if (filename.includes(keyword)) {
        return true;
    }

    let summary = doc.doc_summary.toLowerCase()
    if (summary.includes(keyword)) {
        return true;
    }

    let companyName = doc.peer_corp_name ? doc.peer_corp_name.toLowerCase() : ""
    if (companyName.includes(keyword)) {
        return true;
    }

    return false;
}

function filterDate(doc, filterValues, stats) {
    let startDate = Number(filterValues.startYear)
    let endDate = Number(filterValues.endYear)
    let year = Number(doc.year);

    if (doc.year === null || doc.year === undefined || year === 0 || isNaN(year))
        return true;

    if (startDate <= year && year <= endDate)
        return true;

    return false;
}

function filterRegion(doc, filterValues) {
    let filterRegion = filterValues.epaRegion.toString()
    let docRegion = doc.region.toString()

    if (filterRegion === '') {
        return true;
    }

    return docRegion === filterRegion
}

function filterEpaType(doc, filterValues) {
    let filterType = filterValues.epaType
    let docType = doc.epa_activity_type

    if (filterType === "")
        return true

    return docType === filterType
}

function filterFileSource(doc, filterValues) {
    let filterSources = Array.isArray(filterValues.foiaSource)
        ? filterValues.foiaSource
        : (filterValues.foiaSource ? [filterValues.foiaSource] : [])
    let docSource = doc.file_source

    if (filterSources.length === 0) {
        return true;
    }

    return filterSources.includes(docSource)
}

function filterStatute(doc, filterValues) {
    let docStatute = doc.statute
    let filterStatutes = filterValues.statute || []

    if (filterStatutes.length === 0) {
        return true;
    }

    return filterStatutes.includes(docStatute)
}

function filter(doc, filterValues, stats) {
    if (!filterKeyword(doc, filterValues))
        return false;

    if (!filterDate(doc, filterValues, stats))
        return false;

    if (!filterRegion(doc, filterValues))
        return false;

    if (!filterEpaType(doc, filterValues))
        return false;

    if (!filterFileSource(doc, filterValues))
        return false;

    if (!filterStatute(doc, filterValues))
        return false;

    return true;
}

function SearchSection() {
    const { isLoading, applyFilter, resetFilter, stats, filter: appliedFilter } = useDocs();
    const location = useLocation();
    const [filterValues, setFilterValues] = useState(appliedFilter);

    let presetRegion = new URLSearchParams(location.search).get('epaRegion') || '';
    let [hasAppliedPreset, setHasAppliedPreset] = useState(false);

    useEffect(() => {
        if (presetRegion === '' || hasAppliedPreset || isLoading) {
            return;
        }

        let validRegion = presetRegion === 'HQ' || /^\d+$/.test(presetRegion);

        if (!validRegion) {
            setHasAppliedPreset(true);
            return;
        }

        let nextFilterValues = { ...originalFilter, epaRegion: presetRegion };
        setFilterValues(nextFilterValues);
        applyFilter((doc) => filter(doc, nextFilterValues, stats), nextFilterValues)
        setHasAppliedPreset(true);
    }, [applyFilter, hasAppliedPreset, isLoading, presetRegion, stats]);

    const actionTrigger = (type) => {
        switch (type) {
            case 'search':
                setHasAppliedPreset(true)
                applyFilter((doc) => filter(doc, filterValues, stats), filterValues)
                break;
            case 'clear':
                setHasAppliedPreset(true)
                setFilterValues(originalFilter)
                resetFilter()
                break;
            default:
                break;
        }
    }

    return (
        <Section header={<Header />} >
            <Filter values={filterValues} onChange={setFilterValues} />
            <Action actionTrigger={actionTrigger} />
        </Section>
    )
}

export default SearchSection;